import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class OnlineNipsService {
  constructor(private http: HttpClient) {}

  getActiveNips(pageIndex: number, perPage: number, queryParams, sort) {
    return this.http.get<any>(
      `${environment.apiUrl}/api/reports/active-nips?page=${pageIndex}&per_page=${perPage}&${queryParams}${sort}`
    );
  }

  exportToCSV() {
    return this.http
      .get<any>(`${environment.apiUrl}/api/reports/excel/active-nips`)
      .pipe(
        map((responseData) => {
          return responseData;
        })
      );
  }
}
